import { Injectable } from '@angular/core';
import { SyskcServicePkg } from './syskcPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyskcService extends SyskcServicePkg {
  constructor() {
    super();
  }
}
